import {
  Modal,
  ModalInputWrapper,
  ModalInputRadio,
  modalConnect,
  ModalFooter,
  ModalButton,
} from "@modal";
import { ceModalUpdateState } from "@js/actions/studio/modals.js";

import {
  ceModalChangeHtmlEditorCancel,
  ceModalChangeHtmlEditorSave,
  ceModalChangeHtmlEditorConfirm,
} from "@js/actions/studio/campaign_content_section/modal_change_html_editor.js";

export default modalConnect((props) => {
  switch (props.step) {
    case "select":
      return <ModalChangeHtmlEditorSelect />;
    case "confirm":
      return <ModalChangeHtmlEditorConfirm />;
    default:
      return null;
  }
});

const ModalChangeHtmlEditorSelect = modalConnect((props) => {
  let updateValue = (e) => {
    props.dispatch(ceModalUpdateState({ active_html_editor: e.target.value }));
  };

  return (
    <Modal
      title={t("phrases.react_content.action_dropdown.change_editor")}
      onCancel={() => props.dispatch(ceModalChangeHtmlEditorCancel())}
      onSave={() => props.dispatch(ceModalChangeHtmlEditorSave())}
    >
      <ModalInputWrapper
        hint={t(`content_editor.html_editor_descriptions.bee`)}
      >
        <ModalInputRadio
          label={t(`content_editor.html_editor_descriptions.bee_label`)}
          value="bee"
          name="active_html_editor"
          selectedValue={props.active_html_editor}
          onChange={updateValue}
        />
      </ModalInputWrapper>

      <ModalInputWrapper
        hint={t(`content_editor.html_editor_descriptions.wysiwyg`)}
      >
        <ModalInputRadio
          label={t(`content_editor.html_editor_descriptions.wysiwyg_label`)}
          value="wysiwyg"
          name="active_html_editor"
          selectedValue={props.active_html_editor}
          onChange={updateValue}
        />
      </ModalInputWrapper>

      <ModalInputWrapper
        hint={t(`content_editor.html_editor_descriptions.textarea`)}
      >
        <ModalInputRadio
          label={t(`content_editor.html_editor_descriptions.textarea_label`)}
          value="textarea"
          name="active_html_editor"
          selectedValue={props.active_html_editor}
          onChange={updateValue}
        />
      </ModalInputWrapper>
    </Modal>
  );
});

const ModalChangeHtmlEditorConfirm = modalConnect((props) => {
  let confirmationText = t("phrases.react_content.switch_to") + " ";
  switch (props.active_html_editor) {
    case "bee":
      confirmationText += t(
        `content_editor.html_editor_descriptions.bee_label`,
      );
      break;
    case "textarea":
      confirmationText += t(
        `content_editor.html_editor_descriptions.textarea_label`,
      );
      break;
    case "wysiwyg":
      confirmationText += t(
        `content_editor.html_editor_descriptions.wysiwyg_label`,
      );
      break;
    default:
      confirmationText += "Other editor";
      break;
  }

  return (
    <Modal
      title={t("phrases.react_content.action_dropdown.change_editor")}
      onCancel={() => props.dispatch(ceModalChangeHtmlEditorCancel())}
      onSave={() => {
        props.dispatch(ceModalChangeHtmlEditorConfirm());
      }}
    >
      <div>{props.warning}</div>

      <ModalFooter>
        <ModalButton
          onClick={() => {
            props.dispatch(ceModalChangeHtmlEditorCancel());
          }}
          text={t("buttons.cancel")}
          diminished
        />
        <ModalButton
          onClick={() => {
            props.dispatch(ceModalChangeHtmlEditorConfirm());
          }}
          text={confirmationText}
          dangerous
        />
      </ModalFooter>
    </Modal>
  );
});
